
import { activeCart, activeWishlistIcon, cart, descIcon, titleIcon, wishlistIcon } from '../utils/icons';

const ActionBtn = ({ productId, cartCount, totalWishList, wishList, cartProductsList, setCaption }) => {
    const isInWishList = wishList?.find(product => parseInt(product.id) === productId);
    const isInCartProductExits = cartProductsList?.find(product => parseInt(product.id) === productId);
    const cartPage = window.location.hostname === "localhost" ? "http://localhost/wordpress/cart" : `${window.location.origin}/cart`;

    return (
        <div className='actionBtn'>
            <div className="btnList">
                <a onClick={(e) => {
                    e.preventDefault();
                    setCaption(cap => cap === 'title' ? '' : 'title')
                }}>{titleIcon}</a>
                <a href={cartPage} className={`wishlist ${isInCartProductExits ? 'productExit' : ''}`} > {isInCartProductExits ? activeCart : cart}{cartCount}</a>
                <a href='' onClick={(e) => e.preventDefault()} className={`wishlist ${isInWishList ? 'productExit' : ''}`}> {isInWishList ? activeWishlistIcon : wishlistIcon}{totalWishList}</a>
                <a href='' onClick={(e) => {
                    e.preventDefault();
                    setCaption(cap => cap === 'description' ? '' : 'description')
                }}>{descIcon}</a>
            </div>
        </div>
    );
};
export default ActionBtn;

